// @flow
import * as React from 'react';
import { useParams } from 'react-router-dom';
import {
  PageTitle,
  useSessionStorageState
} from '../../../shared';
import { keycloak } from '@coverright/shared/keycloak';
import { useContacted } from '../hooks/use-contacted';
import { ClientViewSortInput, Field, PageInput, SortDirection } from '@coverright/data-access/types/enrollment';
import { DashboardDataGrid } from '../ui/dashboard-data-grid';
import { useEffect } from 'react';

export const Contacted = () => {
  const {agentId} = useParams<{ agentId?: string }>();
  const [page, setPage] = usePage();
  const [sort, setSort] = useSort();

  useEffect(() => {
    setPage(p => ({...p, page: 0}))
  }, [agentId]);

  const {total, loading, clients} = useContacted({
    agentId: agentId || keycloak?.tokenParsed?.sub,
    pageInput: page,
    sort,
  });

  return (
    <>
      <PageTitle title={`Contacted`} />

      <DashboardDataGrid page={page.page}
                         rowsPerPage={page.size}
                         total={total}
                         loading={loading}
                         sort={sort}
                         onSortModelChange={setSort}
                         onPageChange={p => setPage(prev => ({...prev, page: p }))}
                         onRowsPerPageChange={p => setPage(prev => ({...prev, size: p }))}
                         rows={clients}/>
    </>
  );
};

const usePage = () => {
  return useSessionStorageState<PageInput>(
    'contactedPage',
    { page: 0, size: 20 }
  );
};

const useSort = () => {
  return useSessionStorageState<ClientViewSortInput | undefined>(
    'contactedSort',
    {field: Field.CreatedAt, direction: SortDirection.Desc}
  )
}
